export default "__VITE_ASSET__96377983__"